import { IPasstRotuloModel } from "../interfaces/passt/IPasstRotuloModel";
import { PasstObtjetivoModel } from "./PasstObtjetivoModel";

export class PasstRotuloModel implements IPasstRotuloModel{
    idPasst:number;
    anio:number;
    nombreSede?:string;
    idSede:number;
    titulo:string;
    razonSocial:string;
    ruc:string;
    direccion:string;
    actividadEconomica:string;
    nroTrabajadores:number;
    aprobadoPor:string;
    fechaAprobacion?:Date;
    fechaActualizacion?:Date;
    frecuenciaMedicion:string;
    objetivo:string;
    meta:string;
    editable:boolean;
    
    objetivos: Array<PasstObtjetivoModel>;

    constructor(){
        this.idPasst = 0;
        this.anio=0;
        this.idSede = 0;
        this.titulo ='';
        this.razonSocial ='';
        this.ruc ='';
        this.direccion ='';
        this.actividadEconomica ='';
        this.aprobadoPor ='';
        this.nroTrabajadores = 0;
        this.frecuenciaMedicion ='';
        this.objetivo ='';
        this.meta ='';
        this.editable = false;
        this.objetivos = new Array<PasstObtjetivoModel>();
    }
}